import script from "./UserSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSignup.vue?vue&type=script&setup=true&lang=js"

import "./UserSignup.vue?vue&type=style&index=0&id=889a449e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889a449e"]])

export default __exports__